<script>
import { Bar } from "vue-chartjs";

export default {
    extends: Bar,
    props: {
        labels: {
            type: Array,
            default: () => ({})
        },
        options: {
            type: Object,
            default: () => ({
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                    display: false
                },
                scales: {
                    xAxes: [
                        {
                            offset: true,
                            ticks: {
                                autoSkip: true,
                                maxRotation: 0,
                                minRotation: 0,
                                callback: function(val, index) {
                                    // Hide every 2nd tick label
                                    return index % 2 === 0 ? val : '';
                                }
                            },
                            gridLines: {
                                display:false
                            }
                        }
                    ],
                    yAxes: [
                        {
                            ticks: {
                                autoSkip: true,
                                callback: function(val, index) {
                                    // Hide every 2nd tick label
                                    return index % 2 === 0 ? val : '';
                                }
                            }
                        }
                    ]
                },
                datasets: {
                    barThickness: 8
                }
            })
        },
        data: {
            type: Array,
            default: () => ([])
        },
        chartLabel: {
            Type: String,
            default: "Label"
        },
        backgroundColor: {
            Type: String,
            default: getComputedStyle(document.body).getPropertyValue('--chartColor')
        },
        width: {
            Type: Number,
            default: 200
        },
        height: {
            Type: Number,
            default: 200
        }
    },
    mounted() {
        this.render();
    },
    methods: {
        render() {
            this.renderChart(
                {
                    labels: this.labels,
                    datasets: [
                        {
                            label: this.chartLabel,
                            backgroundColor: this.backgroundColor,
                            data: this.data
                        }
                    ]
                },
                this.options
            );
        }
    },
    watch: {
        data() {
            this.render();
        }
    }
};
</script>
